import OrderCURModule from "@/modules/OrderCUR";

function CreateOrderPage() {
  return <OrderCURModule type="create" />;
}

export default CreateOrderPage;
